import { render, staticRenderFns } from "./MusicForAllFormComponent.vue?vue&type=template&id=5ed0630e&scoped=true&"
import script from "./MusicForAllFormComponent.vue?vue&type=script&lang=ts&"
export * from "./MusicForAllFormComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed0630e",
  null
  
)

export default component.exports